module.exports = require("events");


/*****************
 ** WEBPACK FOOTER
 ** external "events"
 ** module id = 326
 ** module chunks = 0
 **/